import React from 'react'
import moment from 'moment'
import { TAG_SIZE, TAG_STYLE, Tag } from 'transfix-ui'
import { FORMATS } from 'constants/datetime'

interface IEffectiveDateTag {
  tagStyle: TAG_STYLE
  effectiveDate: string
  expirationDate: string
}

const EffectiveDateTag = ({ effectiveDate, expirationDate, tagStyle }: IEffectiveDateTag) => {
  const formattedEffectiveDate = moment(effectiveDate).format(FORMATS.dateFormat)
  const formattedExpirationDate = moment(expirationDate).format(FORMATS.dateFormat)

  return (
    <Tag
      label={`Effective ${formattedEffectiveDate} - ${formattedExpirationDate}`}
      tagStyle={tagStyle}
      size={TAG_SIZE.xsmall}
    />
  )
}

export default EffectiveDateTag
